export class CSMode {
  constructor(
    readonly status: 'enabled' | 'disabled',
    readonly facilityId: string,
  ) {}
}
